import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import TruncateText from "core/TruncateText";
import colors from "core/colors";
import Flexbox from "core/Flexbox";
import SrOnly from "core/SrOnly";

import {
    StyledCheckoutNav,
    BackLink,
    BackButtonIcon,
    BackButtonText,
    InfoWrapper,
    Thumbnail,
    Title,
    Logo,
    BackButtonIconAndTextWrapper,
    NpLogoAnchor
} from "./styles";

import { homePath } from "data/links";

const CheckoutNavBar = ({ className, thumbnail, imageTitle, type }) => {
    return (
        <StyledCheckoutNav
            bgColor={colors.primary.snow}
            topSpacing="none"
            bottomSpacing="none"
            className={className}
        >
            <Flexbox alignItems="center">
                <BackLink onClick={() => window.history.back()}>
                    <BackButtonIconAndTextWrapper
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <BackButtonIcon width="16px" height="12.8px" />
                        <BackButtonText size={12}>Back</BackButtonText>
                    </BackButtonIconAndTextWrapper>
                    <InfoWrapper inlineFlex alignItems="center">
                        <Thumbnail src={thumbnail} alt={imageTitle} />
                        <Title>
                            <TruncateText charLimit={51}>
                                {imageTitle}
                            </TruncateText>
                        </Title>
                    </InfoWrapper>
                </BackLink>
            </Flexbox>
            <NpLogoAnchor href={homePath.url}>
                <SrOnly>{homePath.alt}</SrOnly>
                <Logo title={homePath.alt} />
            </NpLogoAnchor>
        </StyledCheckoutNav>
    );
};

CheckoutNavBar.propTypes = {
    type: PropTypes.oneOf(["icons", "photos"]),
    imageTitle: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    className: PropTypes.string
};

const Navbar = styled(CheckoutNavBar)``;

export default Navbar;
